import React, { useEffect, useState } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

// @ts-ignore
import reducer from './reducer';
// @ts-ignore
import { setToken } from './requests';
import { ActivityState } from './types';

export type Props = {
  children: React.ReactNode;
  token: string | null;
};

const createProvider = (initialState: ActivityState) => {
  const store = createStore(reducer, initialState, applyMiddleware(thunk));

  return (props: Props) => {
    useEffect(() => {
      if (props.token) {
        setToken(props.token);
      }
    }, [props.token]);

    return <ReduxProvider store={store}>{props.children}</ReduxProvider>;
  };
};

export default createProvider;
